export default __webpack_public_path__ + "static/study-3-mobile-6b25f42c20380bdedc3bb9d30f14080e.jpg";